import { getIsFlatTourBookingEnabled } from './getIsFlatTourBookingEnabled';
import { IAppState } from '../../common/state';
import { getNewbuildingId } from '../newbuildingHeader';

export function canMakeFlatViewOrder(state: IAppState): boolean {
  const isEnabled = getIsFlatTourBookingEnabled(state);
  const newbuildingId = getNewbuildingId(state);

  return Boolean(newbuildingId && isEnabled);
}
